import { useRef } from "react";
import { useShallow } from "zustand/shallow";

import { useBoundStore } from "@/app/store";
import { FolderFormContent, FolderFormValues } from "./FolderFormContent";
import { Modal } from "@/shared/components/common/Modal";

interface FolderModalProps {
  id: string;
  initialValues?: FolderFormValues;
  isOpen: boolean;
  onSave: (values: FolderFormValues) => Promise<void>;
  onOpenChange: (open: boolean) => void;
}

export function ManageFolder({ id, initialValues, isOpen, onOpenChange, onSave }: FolderModalProps) {
  const deviceType = useBoundStore(useShallow((state) => state.device.type));
  const formRef = useRef<{ submit: () => void; reset: () => void } | null>(null);

  const handleOpenChange = (open: boolean) => {
    if (!open) {
      formRef.current?.reset();
    }
    onOpenChange(open);
  };

  return (
    <Modal
      id={id}
      title={initialValues ? "Edit folder" : "New folder"}
      closeLabel="Cancel"
      confirmLabel={initialValues ? "Save" : "Create"}
      onConfirm={() => formRef.current?.submit()}
      externalState={{ isOpen, onOpenChange: handleOpenChange }}
    >
      <FolderFormContent
        ref={formRef}
        initialValues={initialValues}
        deviceType={deviceType}
        onClose={() => handleOpenChange(false)}
        onSubmit={onSave}
      />
    </Modal>
  );
}
